import React from 'react';
import DeleteObject from '../../common/poppers/DeleteObject';
import CorrectionRow from '../correction/CorrectionRow';
import ModifyCorrection from '../correction/ModifyCorrection';
import TaxTransitionRow from '../tax/taxtype/TaxTransitionRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

export const balanceActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Korrekció módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => "CORRECTION_FIX" === row.balanceRowType || "CORRECTION_MODIFY" === row.balanceRowType,
        actionComponent: (props, close) => <ModifyCorrection {...props} close={close} />
    },
    {
        canShow: (row) => "CORRECTION_FIX" === row.balanceRowType || "CORRECTION_MODIFY" === row.balanceRowType || "TAX_TRANSITION" === row.balanceRowType,
        divider: true,
    },
    {
        dataDialog: "delete-correction-dialog",
        title: "Törlés",
        dialogTitle: "Korrekció törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        canShow: (row) => "CORRECTION_FIX" === row.balanceRowType || "CORRECTION_MODIFY" === row.balanceRowType,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/correction'} comp={<CorrectionRow {...props} />} />
    },
    {
        dataDialog: "delete-transition-dialog",
        title: "Törlés",
        dialogTitle: "Átvezetés törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        canShow: (row) => "TAX_TRANSITION" === row.balanceRowType,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/taxtransition'} comp={<TaxTransitionRow {...props} />} />
    },
]